import { Maybe, NestedLink } from '@/graphql/gql/graphql';
import { useState } from 'react';
import { filterEmpty } from '@/utils/index';
import Styles from './MobileNavigation.module.scss';
import MobileMenuItem from './MobileMenuItem';

type MobileNavigationProps = {
  menuItems: Maybe<NestedLink>[],
};

const MobileNavigation = ({ menuItems }:MobileNavigationProps) => {
  const [activeSport, setActive] = useState<string>();

  return (
    <div className={Styles.container}>
      <ul className={Styles.sportList}>
        {filterEmpty(menuItems).map((menuItem, index) => (

          <MobileMenuItem
            key={menuItem.url}
            {...menuItem}
            setActive={setActive}
            activeSport={activeSport}
            index={index}
          />

        ))}
      </ul>
    </div>
  );
};

export default MobileNavigation;
